<template>
  <div class="face-capture">
    <div class="tips" v-if="!isOperate">
      <img class="renlian" src="@/assets/images/renlian.png" alt="" />
      <div class="tips-message">为保障投保信息真实有效</div>
      <div class="tips-message">人脸信息仅能由本人完成采集</div>
      <div class="tips-message">确保在良好的光照条件下使用，以提高检测精度</div>
      <div class="tips-message">尝试正对摄像头，避免大幅度的头部转动</div>
    </div>
    <!-- 拍照呈现出来的图片 -->
    <div v-show="capturedImage" class="result">
      <img :class="{ 'ios-video': isIOS }" style="width: 450px; height: 300px;" :src="capturedImage" alt="Captured Face" />
    </div>
    <video id="video" v-show="!capturedImage" :class="{ 'ios-video': isIOS }" width="500" height="450" ref="video" playsinline webkit-playsinline muted @loadedmetadata="onVideoLoaded"></video>
    <div v-show="!capturedImage">
      <canvas id="canvas" ref="canvas" width="400" height="300"></canvas>
      <!-- 取景框 -->
      <!-- <img v-if="isOperate" style="width: 450px; height: 300px;" class="reg-img" src="@/assets/images/recognition.png" alt="" /> -->
    </div>
    <!-- iOS 专用播放按钮 -->
    <!-- <button v-if="showPlayButton && isIOS" @click="playVideoManually" class="ios-play-button">
      ▶ 点击播放视频
    </button> -->
    <div class="confirm">
      <van-button v-if="!capturedImage && isOperate && !lock" class="confirm-btn" color="#E99D42" @click="capture">拍照</van-button>
      <van-button v-if="!capturedImage && isOperate && lock" class="confirm-btn" color="#E99D42" disabled>扫描识别人脸中，请将人脸置入取景框内，尝试正对摄像头，避免大幅度的头部转动</van-button>
      <van-button v-if="capturedImage" class="confirm-btn" color="#E99D42" @click="handleRePhoto">重新拍照</van-button>
      <van-button v-if="!isOperate" class="confirm-btn" color="#E99D42" @click="startCamera">进入人脸采集</van-button>
      <van-button v-if="isOperate" :disabled="!capturedImage" class="confirm-btn" color="#E99D42" @click="handleUploadPhoto">上传完成采集</van-button>
    </div>
    <!-- <button @click="stopCamera">关闭摄像头</button> -->
  </div>
</template>

<script>
// eslint-disable-next-line
import tracking from '@/assets/tracking/build/tracking-min.js'
import '@/assets/tracking/build/data/face-min.js'
import { verifyFacePhoto } from '@/service/insurance'

export default {
  data() {
    return {
      info: {},
      form: {},
      isOperate: false,
      showPlayButton: false,
      video: null,
      canvas: null,
      context: null,
      tracker: null,
      capturedImage: null,
      stream: null,
      faceCount: 0,
      lock: false, // 拍摄锁
      rect: null // 人脸信息
    }
  },
  computed: {
    isIOS() {
      return ['iPad', 'iPhone', 'iPod'].includes(navigator.platform) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    }
  },
  mounted() {
    if (sessionStorage.getItem('form')) {
      this.form = JSON.parse(sessionStorage.getItem('form'))
    }
    if (sessionStorage.getItem('info')) {
      this.info = JSON.parse(sessionStorage.getItem('info'))
    }
    // this.video = document.getElementById('video')
    // this.canvas = document.getElementById('canvas')
    this.video = this.$refs.video
    document.getElementById('video').style.display = 'none'
    this.canvas = this.$refs.canvas
    this.context = this.canvas.getContext('2d')
    console.log(this.context, 'context')
    // 检查 tracking 是否全局可用
    if (typeof window.tracking === 'undefined') {
      console.error('tracking.js 未正确加载')
      console.log('人脸检测库加载失败，请刷新页面重试', 'error')
      return
    }
    // 初始化人脸追踪
    this.tracker = new window.tracking.ObjectTracker('face')
    // 设置初始图像缩放因子
    this.tracker.setInitialScale(4)
    // 设置每一步扫描的步长
    this.tracker.setStepSize(2)
    // 设置图像中边缘的密度
    this.tracker.setEdgesDensity(0.1)
    console.log(this.tracker, 'this.tracker')

    window.tracking.track(this.video, this.tracker)

    this.tracker.on('track', (event) => {
      this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
      // console.log(event.data.length, 'vent.data.length')
      this.faceCount = event.data.length
      // console.log(this.faceCount, 'faceCount')
      event.data.forEach((rect) => {
        // this.context.strokeStyle = '#a64ceb'
        // console.log(this.context, 'context')
        // this.context.strokeRect(rect.x, rect.y, rect.width, rect.height)
        // console.log(rect, 'rect')
        // console.log(index, 'index')
        this.rect = rect
        if (this.lock) {
          this.context.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height)
          this.capturedImage = this.canvas.toDataURL('image/png')
          this.lock = false
        }
      })
    })
  },
  beforeDestroy() {
    this.stopCamera()
    if (this.tracker) {
      this.tracker.removeAllListeners()
    }
  },
  methods: {
    // 上传照片
    handleUploadPhoto() {
      if (!this.capturedImage) {
        this.$toast('请先进行拍照操作！')
        return false
      }
      console.log(this.capturedImage, 'capturedImage')
      let file = this.dataURLtoBlob(this.capturedImage)
      file.name = Date.now() + '.png'
      // blob转file
      let fileCompressed = this.blobToFile(file, file.name)
      this.uploadFinalFile(fileCompressed)
    },
    uploadFinalFile(file) {
      let formData = new FormData()
      formData.append('file', file, file.name)
      formData.append('userIdCard', this.info.userIdCard)
      formData.append('userName', this.info.userName)
      // 人脸认证
      verifyFacePhoto(formData)
        .then((res) => {
          if (res.msg == '系统判断为同一人') {
            this.form.recognitionResult = res.data
            this.$toast.success('识别成功')
            setTimeout(() => {
              sessionStorage.setItem('form', JSON.stringify(this.form))
              this.$router.replace('/signature')
            })
          } else {
            this.$toast(res.msg || '识别错误')
          }
        })
        .catch(() => {
          this.$toast('识别错误')
        })
    },
    //将base64转换为blob
    dataURLtoBlob(dataurl) {
      console.log(dataurl, 'dataurl')
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    //将blob转换为file
    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    // 重新拍照片
    handleRePhoto() {
      this.capturedImage = null
      this.startCamera()
    },
    // iOS 专用的视频播放方法
    playVideoManually() {
      if (this.video) {
        this.video
          .play()
          .then(() => {
            this.showPlayButton = false
            console.log('手动播放成功')
          })
          .catch((error) => {
            console.error('手动播放失败:', error)
          })
      }
    },

    onVideoLoaded() {
      if (this.isIOS) {
        // iOS 上视频加载完成后的特殊处理
        this.video.setAttribute('playsinline', 'true')
        this.video.setAttribute('webkit-playsinline', 'true')
      }
    },
    async startCamera() {
      this.isOperate = true
      try {
        // 1. 首先检查是否支持媒体设备
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          throw new Error('您的浏览器不支持摄像头访问')
        }

        // 2. 获取设备列表（可选）
        const devices = await navigator.mediaDevices.enumerateDevices()
        const hasCamera = devices.some((device) => device.kind === 'videoinput')
        if (!hasCamera) {
          throw new Error('未检测到摄像头设备')
        }
        document.getElementById('video').style.display = 'block'
        // 3. 尝试获取媒体流
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: {
            width: { ideal: 400 },
            height: { ideal: 500 },
            facingMode: 'user',
            // 可添加更多约束
            frameRate: { ideal: 30 }
          },
          audio: false
        })

        // this.video.srcObject = this.stream
        // return true
        this.video = this.$refs.video
        this.video.srcObject = this.stream

        // iOS 需要手动播放并且等待用户交互
        this.video.playsInline = true // 关键：允许内联播放
        this.video.muted = true // 静音以提高自动播放成功率

        const playPromise = this.video.play()

        if (playPromise !== undefined) {
          playPromise.catch(() => {
            // iOS 自动播放被阻止，需要用户手动触发
            console.log('自动播放被阻止，需要用户交互')
            this.showPlayButton = true
          })
        }
      } catch (err) {
        console.error('摄像头开启失败:', err)

        let errorMessage = '摄像头开启失败'
        switch (err.name) {
          case 'NotAllowedError':
            errorMessage = '请允许摄像头访问权限，并重新进入应用'
            break
          case 'NotFoundError':
          case 'DevicesNotFoundError':
            errorMessage = '未找到可用的摄像头设备'
            break
          case 'NotReadableError':
            errorMessage = '暂无摄像头权限或者摄像头被其他应用程序占用，请关闭其他可能使用摄像头的应用，并重新进入应用'
            break
          case 'OverconstrainedError':
            errorMessage = '无法满足摄像头参数要求，请尝试其他浏览器或设备'
            break
          case 'SecurityError':
            errorMessage = '出于安全原因，浏览器阻止了摄像头访问。请确保使用HTTPS或localhost'
            break
          default:
            errorMessage = `摄像头开启失败: ${err.message}`
        }

        alert(errorMessage)
        return false
      }
    },
    stopCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop())
        this.stream = null
        this.video.srcObject = null
      }
    },
    capture() {
      if (!this.stream) {
        this.$toast('请先开启摄像头')
        return
      }
      // if (this.faceCount == 0) {
      //   this.$toast('请将人脸置入取景框内，尝试正对摄像头，避免大幅度的头部转动')
      //   return
      // }
      // if (this.faceCount > 1) {
      //   this.$toast('请勿同时拍摄多个人脸')
      //   return
      // }
      this.lock = true
      // this.context.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height)
      // this.capturedImage = this.canvas.toDataURL('image/png')
    }
  }
}
</script>

<style lang="stylus" scoped>
.tips{
  text-align: center
  .renlian{
    z-index: 999
    margin: 30px auto
    width: 600px
    height: 600px
  }
  .tips-message{
    font-size: 32px
    line-height: 40px
  }
}
.ios-video {
  transform: scaleX(-1); /* 镜像翻转 */
}
.face-capture {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin: 20px;
}

button {
  padding: 8px 16px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #45a049;
}

video,canvas,.reg-img{
  text-align: center;
  max-width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  // border: #000000 5px solid;
}
// video{
//   width: 100%
//   heigth: 100%
//   object-fit:fill
// }
.reg-img{
  text-align: center
  margin: 0 auto
  margin-top: 20px
  padding: 0 50px;
}

.result {
  // margin-top: 20px;
  text-align: center;
}

.result img {
  position: absolute;
  top: 0;
  left: 0;
  max-width: 100%;
  border: 1px solid #ddd;
  border-radius: 4px;
  // margin-bottom: 10px;
}
.confirm{
  position: fixed
  bottom: 20px
  margin: 30px auto
  text-align: center
  .confirm-btn{
    margin-bottom: 10px
    border-radius: 20px
    width: 720px
  }
}
</style>
